import { useEffect, useRef, useState } from "react";

let lottieLoaderPromise = null;
const loadLottie = () => {
  if (lottieLoaderPromise) return lottieLoaderPromise;
  lottieLoaderPromise = import("lottie-web/build/player/lottie_light").then(mod => mod.default || mod);
  return lottieLoaderPromise;
};

const LottieEmbed = ({ src, loop = true, autoplay = true, height = 220, width = "100%", playOnHover = false, className }) => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    loadLottie()
      .then((lottie) => {
        if (!isMounted || !containerRef.current) return;
        const params = {
          container: containerRef.current,
          renderer: "svg",
          loop,
          autoplay: playOnHover ? false : autoplay,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid meet",
          },
        };

        // Support passing either a URL string (path) or an imported JSON object (animationData)
        if (typeof src === 'string') {
          params.path = src;
        } else if (src && typeof src === 'object') {
          params.animationData = src;
        } else {
          throw new Error('LottieEmbed: invalid `src` prop — expected string URL or animation JSON');
        }

        animationRef.current = lottie.loadAnimation(params);
      })
      .catch((err) => {
        console.error("Failed to load lottie", err);
        if (isMounted) setError("Lottie failed to load");
      });

    return () => {
      isMounted = false;
      if (animationRef.current) {
        animationRef.current.destroy();
      }
    };
  }, [src, loop, autoplay, playOnHover]);

  const handleMouseEnter = () => {
    if (playOnHover && animationRef.current) {
      animationRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (playOnHover && animationRef.current) {
      animationRef.current.stop();
    }
  };

  return (
    <div
      className={className} 
      style={{ width, height }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={containerRef}
        style={{ width: "100%", height: "100%", cursor: playOnHover ? "pointer" : "default" }}
        aria-label="lottie-animation"
      />
      {error && (
        <p style={{ color: "var(--error-color)", marginTop: "0.5rem", fontSize: "0.9rem" }}>
          {error}
        </p>
      )}
    </div>
  );
};

export default LottieEmbed;
